// @flow
import type { PaginationHeaders } from '@globalTypes';

import {
  PACKAGE_SEARCH_REQUEST,
  PACKAGE_SEARCH_REQUESTED,
  PACKAGE_SEARCH_REQUESTED_ERROR,
  PACKAGE_SEARCH_RESET,
  PACKAGE_SEARCHBAR_REQUEST,
  PACKAGE_SEARCHBAR_REQUESTED
} from './constants';

import type { Action, Packages } from '../types';

export const requestPackageList = (
  requestPayload: {
    doctor_id?: string,
    pageNumber?: string,
    treatment_id?: string,
    location?: string,
    country?: string,
    departments?: string,
    custom_items_per_page?: string,
    name?: string,
    facility_id?: string
  } = {}
): Action => ({
  type: PACKAGE_SEARCH_REQUEST,
  ...requestPayload
});
export const requestPackageListSearchBar = (
  requestPayload: {
    pageNumber?: string,
    query?: string,
    treatment_id?: string,
    searchQuery?: string,
    location?: string,
    country?: string,
    name?: string
  } = {}
): Action => ({
  type: PACKAGE_SEARCHBAR_REQUEST,
  ...requestPayload
});

export const updatePackageListSearchBar = (
  data: Packages,
  headers: PaginationHeaders,
  requestPayload: {
    treatment_id?: string,
    pageNumber?: string,
    query?: string,
    search_query?: string,
    location?: string,
    country?: string,
    name?: string
  } = {}
): Action => ({
  type: PACKAGE_SEARCHBAR_REQUESTED,
  data,
  headers,
  ...requestPayload
});
export const updatePackageList = (
  data: Packages,
  included: [],
  headers: PaginationHeaders
): Action => ({
  type: PACKAGE_SEARCH_REQUESTED,
  data,
  headers,
  included
});

export const errorPackageList = (error: Error): Action => ({
  type: PACKAGE_SEARCH_REQUESTED_ERROR,
  error
});

export const resetPackageList = (): Action => ({
  type: PACKAGE_SEARCH_RESET
});
